<template>
	<div class='register-component'>

		<div class='register-form-box-outer'>
			<div class='register-form-box'>

				<table>
					<tbody>
						<tr>
							<td class='label-col'>Логин</td>
							<td><input v-model='login'></td>
						</tr>
						<tr>
							<td class='label-col'>Имя пользователя</td>
							<td><input v-model='user_name'></td>
						</tr>
						<tr>
							<td class='label-col'>Филиал</td>
							<td>
								<select v-model='filial_id'>
									<option v-for='filial in info_filials' :value='filial.id' :key='filial.id'>{{filial.name}}</option>
								</select>
							</td>
						</tr>
						<tr>
							<td class='label-col'>Должность</td>
							<td>
								<select v-model='user_post'>
									<option v-for='post in info_users_post' :value='post.name' :key='post.id'>{{post.name}}</option>
								</select>
							</td>
						</tr>
						<tr>
							<td class='label-col'>Роль</td>
							<td>
								<select v-model='role_id'>
									<option v-for='role in info_user_roles' :value='role.id' :key='role.id'>{{role.name}}</option>
								</select>
							</td>
						</tr>
						<tr>
							<td class='label-col'>Телефон</td>
							<td><input v-model='user_phone'></td>
						</tr>
					</tbody>
				</table>

				<div class='register-btn-block'>
					<router-link to='/'>Вернуться</router-link>
					<button @click='register' class='register-btn'>Зарегистрировать</button>
				</div>

			</div>
		</div>

	</div>
</template>

<script>
	import router from '@/router';
	const REGISTER = process.env.VUE_APP_ROOT_API + 'auth/register.php';

	import { mapState } from 'vuex';

	export default {
		name: 'RegisterComponent',
		data: () => ({
			login: null,
			user_name: null,
			user_post: null,
			role_id: null,
			filial_id: null,
			user_post: null,
			user_phone: null
		}),
		computed: {
			...mapState({
				info_filials: state => state.catalogs.info_filials,
				info_users_post: state => state.catalogs.info_users_post,
				info_user_roles: state => state.catalogs.info_user_roles
			})
		},
		methods: {
			register() {

				let isIncorrect = false;

				if (this.login === null || this.login === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо ввести логин', life: 10000});
					isIncorrect = true;
				}
				if (this.user_name === null || this.user_name === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо ввести имя пользователя', life: 10000});
					isIncorrect = true;
				}
				if (this.role_id === null || this.role_id === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо выбрать роль пользователя', life: 10000});
					isIncorrect = true;
				}
				if (this.filial_id === null || this.filial_id === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо выбрать филиал', life: 10000});
					isIncorrect = true;
				}
				if (this.user_post === null || this.user_post === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо ввести должность', life: 10000});
					isIncorrect = true;
				}
				if (this.user_phone === null || this.user_phone === '') {
					this.$toast.add({severity:'warn', detail: 'Необходимо ввести телефон', life: 10000});
					isIncorrect = true;
				}
				if (isIncorrect) {
					return;
				}

				const form = new FormData();
				form.append('login', this.login);
				form.append('user_name', this.user_name);
				form.append('filial_id', this.filial_id);
				form.append('role_id', this.role_id);
				form.append('user_post', this.user_post);
				form.append('user_phone', this.user_phone);

				fetch(REGISTER, {
					method: 'post',
					body: form,
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					console.log(res)
					if ( res.user > 0) {
						this.$toast.add({severity: 'success', detail: 'Пользователь зарегистрирован (обновлен)', life: 10000});
					}
					if (res.code == 0) {
						this.$toast.add({severity: 'success', detail: 'Уведомление успешно отправлено на адрес электронной почты', life: 10000});
					} else {
						this.$toast.add({severity: 'error', detail: 'Письмо не отправлено', life: 10000});
					}
					
				})
				.catch(error => {
					this.$toast.add({severity: 'error', detail: 'Произошла ошибка', life: 10000});
				});
			}
		},
		created() {
			const catalogs = [ 'info_filials', 'info_users_post', 'info_user_roles'];
			this.$store.dispatch('loadCatalogs', catalogs);
		},
	};
</script>

<style scoped>

	.register-component {
		height: 100vh;
		position: relative;
	}

	.register-form-box-outer {
		height: 100%;
		width: 560px;
		margin: auto;

		/*background-color: black;*/
		padding: 40px;

	}

	.register-form-box table {
		width: 100%;
	}

	.register-form-box {
		position: relative;
		top: 50%;
		transform: translateY(-100%);
	}

	/*.back-to-login-block {
		position: absolute;
		left: 20px;
		bottom: 20px;
	}*/

	select {
		width: 100%;
	}

	table td {
		padding-bottom: 10px;
	}

	.label-col {
		text-align: right;
		padding-right: 20px;
		font-weight: bold;
	}

	input,
	select {
		height: 2rem;
		padding: 0 0.5rem;
	}

	input,
	select,
	table,
	button,
	.register-form-box {
		font-size: 1rem;
	}

	.register-btn-block {
		margin-top: 20px;
	}

	.register-btn-block::after {
		display: table;
		content: '';
		clear: both;
	}

	.register-btn {
		float: right;
	}

</style>